const _ = require('lodash');
import { UtilityService } from '../utility.service';

/**
 * This class handles optin timeout.
 */
export class OptinTeimeoutService {
    private utilityService: UtilityService;
    private timer;
    constructor(utilityService) {
        this.utilityService = utilityService;
    }

	setTimerForAgreement() {
		// let storedData = JSON.parse(localStorage.getItem(this.storageKey));
		let isUserInteractionStateSaved = this.utilityService.settingsService
			.firstUserInteraction.stateSaved;
		//todo
		const timeToAutoAgreement = this.utilityService.settingsService.settings
			.optInCountdown;
		if (
			!isUserInteractionStateSaved &&
			timeToAutoAgreement &&
			timeToAutoAgreement > 0
		) {
			if (this.utilityService.settingsService.settings.optInCountdownVisible) {
				this.updateTimerInView(timeToAutoAgreement);
			}
			setTimeout(() => {
				const action = 'onCountdownFinished';
				const updatedBy = 'implicit';
				isUserInteractionStateSaved = this.utilityService.settingsService
					.firstUserInteraction.stateSaved;
				if (!isUserInteractionStateSaved) {
					this.utilityService.settingsService.saveFirstUserInteraction();
					this.utilityService.saveConsentsService.acceptAllConsents(
						action,
						updatedBy
					);
					this.utilityService.UserCentricViewController.updateView();
				}
			}, timeToAutoAgreement * 1000);
		}
	}

    updateTimerInView(timeToAutoAgreement) {
        let displayTime = timeToAutoAgreement;
        this.timer = setInterval(() => {
            const displayDiv = document.getElementById('uc-optin-timer-display');
            if (displayDiv) {
                displayDiv.innerHTML = displayTime;
                --displayTime;
            }
            if (displayTime === 0) {
                clearInterval(this.timer);
            }
        }, 1000);
    }

    stopTimer() {
        if (!this.timer) {
            return;
        }
        clearInterval(this.timer);
        const displayDiv = document.getElementById('uc-optin-timer-display');
        if (displayDiv) {
            displayDiv.innerHTML = '';
        }
    }
}
